import Vue from 'vue';

export default Vue.extend({
  methods: {
    isRoute(action): boolean {
      return action ? action.indexOf('route="') > -1 : false;
    },
    isLink(action): boolean {
      return action ? action.indexOf('link="') > -1 : false;
    },
    isSelfLink(action): boolean {
      return action ? action.indexOf('link:self="') > -1 : false;
    },
    performAction(action): void {
      let regex;

      if (this.isRoute(action)) {
        regex = /(route=")(.*)(")/g;

        const actionMap = regex.exec(action);
        this.$router.push({ name: actionMap[2] });
      } else if (this.isLink(action)) {
        regex = /(link=")(.*)(")/g;

        const actionMap = regex.exec(action);
        window.open(actionMap[2], '_blank');
      } else if (this.isSelfLink(action)) {
        regex = /(link:self=")(.*)(")/g;
        const actionMap = regex.exec(action);
        window.open(actionMap[2]);
      } else {
        regex = /(\w+):(\S+)/;

        const actionMap = regex.exec(action);

        if (actionMap[1] === 'route') {
          this.$router.push({ name: actionMap[2] });
        }
        if (actionMap[1] === 'link') {
          window.open(actionMap[2], '_blank');
        }
      }
    },
  },
});
